/**
 * legacyCopy entries for CC send errors — ported verbatim from
 * `SuggestedActionForCCError` (howToFixIt) and the inline `CC_SEND_ERROR`
 * branch of `getIssueDetailsText` (whatCausedIt) in `../../ParticipantDialog.tsx`.
 */
import { Link } from '@material-ui/core';
import React, { ReactNode } from 'react';
import { LightMdToJsx } from '../../../../../../services/formatter';
import { CopyPack, Issue, IssueKind } from '../types';

const dataOf = (group: Issue[]) => (group[0].raw as { family: 'CC'; data: any }).data;
const ctxOf = (group: Issue[]) => group[0].ctx;
const md = (text: string | null): ReactNode => (text ? <LightMdToJsx>{text}</LightMdToJsx> : null);

export const ccLegacyCopy: Partial<CopyPack> = {
  [IssueKind.CC__NO_EMAIL]: {
    category: 'CC / receives-a-copy delivery',
    summary: (g) =>
      ctxOf(g).t(`Couldn't send copy to **{{name}}** - missing work email`, {
        name: dataOf(g).displayName
      }),
    whatCausedIt: (g) => ccLegacyCopy[IssueKind.CC__NO_EMAIL]!.summary(g),
    howToFixIt: (g) => md(ctxOf(g).t('Add work email to import source and run a new import'))
  },
  [IssueKind.CC__NO_ACTOR]: {
    category: 'CC / receives-a-copy delivery',
    summary: (g) =>
      ctxOf(g).t(`Couldn't send copy - missing supporting actor **{{actor}}**`, {
        actor: dataOf(g).displayName
      }),
    whatCausedIt: (g) => ccLegacyCopy[IssueKind.CC__NO_ACTOR]!.summary(g),
    howToFixIt: (g) => {
      const c = ctxOf(g);
      const d = dataOf(g);
      if (!c.onOpenParticipant) return null;
      return (
        <div>
          <LightMdToJsx>{c.t('Add this supporting actor to the ')}</LightMdToJsx>
          <Link onClick={() => c.onOpenParticipant?.(d.instance)}>
            {c.t(`Participant's experience`)}
          </Link>
        </div>
      );
    }
  },
  [IssueKind.CC__ROLE_EMAIL_BOUNCED]: {
    category: 'CC / receives-a-copy delivery',
    summary: (g) => {
      const d = dataOf(g);
      return ctxOf(g).t(`Email sent to **{{name}}** ({{email}}) bounced`, {
        name: d.displayName,
        email: d.email
      });
    },
    whatCausedIt: (g) => ccLegacyCopy[IssueKind.CC__ROLE_EMAIL_BOUNCED]!.summary(g),
    howToFixIt: (g) =>
      md(ctxOf(g).t('Create email or contact Support to update the email address in Dado'))
  },
  [IssueKind.CC__FIXED_EMAIL_BOUNCED]: {
    category: 'CC / receives-a-copy delivery',
    summary: (g) => ctxOf(g).t(`Email sent to **{{email}}** bounced`, { email: dataOf(g).email }),
    whatCausedIt: (g) => ccLegacyCopy[IssueKind.CC__FIXED_EMAIL_BOUNCED]!.summary(g),
    howToFixIt: (g) => md(ctxOf(g).t('Update email in Receives a copy settings'))
  }
};
